// src/App.js
import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";

// Components
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import CtaDevis from "./components/CtaDevis";

// Pages
import About from "./pages/About";
import Home from "./pages/Home";
import AccesClients from "./pages/AccesClients";
import CGV from "./pages/CGV";
import Confidentialite from "./pages/Confidentialite";
import Contact from "./pages/Contact";
import Galerie from "./pages/Galerie";
import MentionsLegales from "./pages/MentionsLegales";
import Services from "./pages/Services";
import Professionnels from "./pages/Professionnels";
import Mariage from "./pages/Mariage";

// GA
import { pageview } from "./analytics/ga";

// Styles
import "./App.css";

function AppContent() {
  const location = useLocation();

  useEffect(() => {
    pageview(location.pathname + location.search);
  }, [location]);

  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />

      <main className="flex-grow" role="main">
        <Routes>
          {/* Home */}
          <Route path="/" element={<Home />} />

          {/* Pages */}
          <Route path="/galerie" element={<Galerie />} />
          <Route path="/professionnels" element={<Professionnels />} />
          <Route path="/services" element={<Services />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/acces-clients" element={<AccesClients />} />
          <Route path="/photographe-mariage-nancy"element={<Mariage />}
/>

          {/* Légal */}
          <Route path="/mentions-legales" element={<MentionsLegales />} />
          <Route path="/cgv" element={<CGV />} />
          <Route path="/confidentialite" element={<Confidentialite />} />

          {/* 404 */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>

      <CtaDevis />
      <Footer />
    </div>
  );
}

export default function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}